// module_configs/solar.js
import React from 'react';
import { 
  faGaugeHigh, faUsers, faUserPlus, faUsersLine, faBuilding, faUserTie,
  faBuildingUser, faUserGroup, faIdCard, faCubes, faCube, faListAlt,
  faTruckFast, faCartPlus, faFileInvoice, faReceipt, faArrowRotateLeft,
  faRotateLeft, faListCheck, faQrcode, faPrint, faCartShopping, faClipboardList,
  faArrowRightArrowLeft, faMoneyBillWave, faPlus, faGear, faBullhorn,
  faLayerGroup, faBoxes, faCog, faSun, faUsersCog, faClock,faArrowsLeftRightToLine,
   faHourglassHalf, faHandshake, faSyncAlt
} from '@fortawesome/free-solid-svg-icons';

// Import Solar components
import DashboardHome from '.././module_cosmetics/cosmetics_homedash';

import SolarProducts from '.././module_solar/solar_products';

import SolarProductsList from '.././module_solar/solar_productslist';

import SolarPurchases from '.././module_solar/solar_Purchases';

import SolarPurchaseList from '.././module_solar/solar_PurchaseList';

import SolarReturn from '.././module_solar/solar_Return';

import SolarReturnList from '.././module_solar/solar_returnlist';

import SolarSell from '.././module_solar/solar_Sell';

import SolarSalesList from '.././module_solar/solar_SellList';

import PendingInvoices from '.././module_solar/solar_pendinginvioces';

import PendingInvoicesList from '.././module_solar/solar_pendinginvoiceslist';

import SolarPartners from '.././module_solar/solar_partners';

import SolarPartnersList from '.././module_solar/solar_partnerslist';

import SolarGatepass from '.././module_solar/solar_gatepass';

import SolarGatepassList from '.././module_solar/solar_gatepasslist';

import SolarWarranty from '.././module_solar/solar_warranty';

import SolarWarrantyList from '.././module_solar/solar_warrantylist';

import MechanicsBarcode from '.././module_mechanics/mechanics_BarcodeGenerator';

import MechanicsAddCustomer from '.././module_mechanics/mechanics_customer';

import MechanicsCustomerList from '.././module_mechanics/mechanics_customer_list';

import MechanicsAddSupplier from '.././module_mechanics/mechanics_Supplier';

import MechanicsSuppliersList from '.././module_mechanics/mechanics_SuppliersList';

import MechanicsAddEmployee from '.././module_mechanics/mechanics_employees';

import MechanicsEmployeesList from '.././module_mechanics/mechanic_employeelist';

import RootUsers from '.././module_roots/RootUsers';

import MessageSystem from '.././module_roots/MessageSystem';

import AddTransactionForm from '.././module_cosmetics/cosmetics_addtransactions';

import CosmeticsTransactions from '.././module_cosmetics/cosmetics_transactions';

import CosmeticsSupplierPurchases from '.././module_cosmetics/cosmetics_PurchasesSupplierwise';

import CosmeticsInvoicePurchaseList from '.././module_cosmetics/cosmetics_InvoicePurchaseList';
import StockTransfer from '../module_solar/solar_stocktransfer';
import CentralizedAssignment from '../module_solar_v0/solar_productcentralization';
export const solarConfig = {
  moduleId: 'solar',
  moduleName: 'Solar',
  icon: faSun,
  description: 'Solar Energy Management System',
  
  dashboardComponent: DashboardHome,
  
  roles: {
    'admin_solar': { level: 1, label: 'Admin', color: '#f59e0b' },
    'manager_solar': { level: 2, label: 'Manager', color: '#d97706' },
    'user_solar': { level: 3, label: 'User', color: '#b45309' },
    'viewer_solar': { level: 4, label: 'Viewer', color: '#92400e' }
  },
  
  menuGroups: [
    { id: 'management', name: 'Management', icon: faUsersCog, order: 1 },
    { id: 'inventory', name: 'Inventory & Stock', icon: faBoxes, order: 2 },
    { id: 'sales', name: 'Sales & Transactions', icon: faMoneyBillWave, order: 3 },
    { id: 'system', name: 'System Settings', icon: faCog, order: 4 }
  ],
  
  menus: [
    {
      id: 'dashboard',
      label: 'Dashboard',
      icon: faGaugeHigh,
      component: DashboardHome,
      roles: ['all'],
      groupId: 'management',
      position: 0
    },
    {
      id: 'customers',
      label: 'Customers',
      icon: faUsers,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      groupId: 'management',
      position: 1,
      submenus: [
        {
          id: 'addcustomer',
          label: 'Add Customer',
          component: MechanicsAddCustomer,
          icon: faUserPlus,
          roles: ['admin_solar', 'manager_solar', 'user_solar']
        },
        {
          id: 'customerlist',
          label: 'Customer List',
          component: MechanicsCustomerList,
          icon: faUsersLine,
          roles: ['admin_solar', 'manager_solar', 'user_solar']
        }
      ]
    },
    {
      id: 'suppliers',
      label: 'Suppliers',
      icon: faBuilding,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      groupId: 'management',
      position: 2,
      submenus: [
        {
          id: 'addsupplier',
          label: 'Add Supplier',
          component: MechanicsAddSupplier,
          icon: faUserTie,
          roles: ['admin_solar', 'manager_solar', 'user_solar']
        },
        {
          id: 'supplierlist',
          label: 'Supplier List',
          component: MechanicsSuppliersList,
          icon: faBuildingUser,
          roles: ['admin_solar', 'manager_solar', 'user_solar']
        }
      ]
    },
    {
      id: 'employees',
      label: 'Employees',
      icon: faUserGroup,
      roles: ['admin_solar', 'manager_solar'],
      groupId: 'management',
      position: 3,
      submenus: [
        {
          id: 'addemployees',
          label: 'Add Employee',
          component: MechanicsAddEmployee,
          icon: faUserPlus,
          roles: ['admin_solar', 'manager_solar']
        },
        {
          id: 'employeeslist',
          label: 'Employees List',
          component: MechanicsEmployeesList,
          icon: faIdCard,
          roles: ['admin_solar', 'manager_solar']
        }
      ]
    },
    {
      id: 'partners',
      label: 'Partners',
      icon: faHandshake,
      roles: ['admin_solar', 'manager_solar'],
      groupId: 'management',
      position: 4,
      submenus: [
        {
          id: 'addpartners',
          label: 'Add Partner',
          component: SolarPartners,
          icon: faUserPlus,
          roles: ['admin_solar', 'manager_solar']
        },
        {
          id: 'partnerslist',
          label: 'Partners List',
          component: SolarPartnersList,
          icon: faLayerGroup,
          roles: ['admin_solar', 'manager_solar']
        }
      ]
    },
    {
    id: 'stock',  // Changed from 'name'
    label: 'Stock',  // Changed from 'displayName'
    icon: faCubes,
    roles: ['admin_solar', 'manager_solar', 'user_solar'],
    description: 'Manage Stock',
    groupId: 'inventory',
    submenus: [
        {
            id: 'addstock',  // Changed from 'name'
            label: 'Add Stock',  // Changed from 'displayName'
            component: SolarProducts,
            icon: faCube,
            roles: ['admin_solar', 'manager_solar', 'user_solar'],
        },
        {
            id: 'stocklist',  // Changed from 'name'
            label: 'Stock List',  // Changed from 'displayName'
            component: SolarProductsList,
            icon: faListAlt,
            roles: ['admin_solar', 'manager_solar', 'user_solar'],
        },
        {
            id: 'stocktransfer',
            label: 'Stock Transfer',
            component: StockTransfer,
            icon: faArrowsLeftRightToLine,
            roles: ['admin_solar', 'manager_solar'],
        },
        {
            id: 'stockcentralization',
            label: 'Stock Centralization',
            component: CentralizedAssignment,
            icon: faListAlt,
            roles: ['admin_solar', 'manager_solar'],
        },
    ]
},
    {
      id: 'purchases',
      label: 'Purchase',
      icon: faTruckFast,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      groupId: 'inventory',
      position: 6,
      submenus: [
        {
          id: 'addpurchase',
          label: 'New Purchase',
          component: SolarPurchases,
          icon: faCartPlus,
          roles: ['admin_solar', 'manager_solar', 'user_solar']
        },
        {
          id: 'purchaselist',
          label: 'Purchases List',
          component: SolarPurchaseList,
          icon: faFileInvoice,
          roles: ['admin_solar', 'manager_solar', 'user_solar']
        },
        {
          id: 'purchasessupplierwise',
          label: 'Supplier-wise',
          component: CosmeticsSupplierPurchases,
          icon: faBuilding,
          roles: ['admin_solar', 'manager_solar', 'user_solar']
        },
        {
          id: 'purchasesinvoicewise',
          label: 'Bill-wise',
          component: CosmeticsInvoicePurchaseList,
          icon: faReceipt,
          roles: ['admin_solar', 'manager_solar', 'user_solar']
        }
      ]
    },
    {
      id: 'returns',
      label: 'Returns',
      icon: faArrowRotateLeft,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      groupId: 'inventory',
      position: 7,
      submenus: [
        {
          id: 'addreturn',
          label: 'New Return',
          component: SolarReturn,
          icon: faRotateLeft,
          roles: ['admin_solar', 'manager_solar', 'user_solar']
        },
        {
          id: 'returnlist',
          label: 'Return List',
          component: SolarReturnList,
          icon: faListCheck,
          roles: ['admin_solar', 'manager_solar', 'user_solar']
        }
      ]
    },
    {
      id: 'pendinginvoices',
      label: 'Pending Invoices',
      icon: faLayerGroup,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      groupId: 'sales',
      position: 8,
      submenus: [
        {
          id: 'pendinginvoices',
          label: 'Add Invoice',
          component: PendingInvoices,
          icon: faPlus,
          roles: ['admin_solar', 'manager_solar', 'user_solar']
        },
        {
          id: 'invoiceslist',
          label: 'Invoices List',
          component: PendingInvoicesList,
          icon: faHourglassHalf,
          roles: ['admin_solar', 'manager_solar', 'user_solar']
        }
      ]
    },
    {
      id: 'sales',
      label: 'Sales',
      icon: faCartShopping,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      groupId: 'sales',
      position: 9,
      submenus: [
        {
          id: 'addsale',
          label: 'New Sale',
          component: SolarSell,
          icon: faCartPlus,
          roles: ['admin_solar', 'manager_solar', 'user_solar']
        },
        {
          id: 'saleslist',
          label: 'Sales List',
          component: SolarSalesList,
          icon: faClipboardList,
          roles: ['admin_solar', 'manager_solar', 'user_solar']
        }
      ]
    },
    {
      id: 'gatepass',
      label: 'Gatepass',
      icon: faSyncAlt,
      roles: ['admin_solar', 'manager_solar'],
      groupId: 'sales',
      position: 10,
      submenus: [
        {
          id: 'addgatepass',
          label: 'Add Gatepass',
          component: SolarGatepass,
          icon: faPlus,
          roles: ['admin_solar', 'manager_solar']
        },
        {
          id: 'gatepasslist',
          label: 'Gatepass List',
          component: SolarGatepassList,
          icon: faListAlt,
          roles: ['admin_solar', 'manager_solar']
        }
      ]
    },
    // {
    //   id: 'warranty',
    //   label: 'Warranty',
    //   icon: faClock,
    //   roles: ['admin_solar', 'manager_solar'],
    //   groupId: 'sales',
    //   position: 11,
    //   submenus: [
    //     {
    //       id: 'addwarranty',
    //       label: 'Add Warranty',
    //       component: SolarWarranty,
    //       icon: faPlus,
    //       roles: ['admin_solar', 'manager_solar']
    //     },
    //     {
    //       id: 'warrantylist',
    //       label: 'Warranty List',
    //       component: SolarWarrantyList,
    //       icon: faListAlt,
    //       roles: ['admin_solar', 'manager_solar']
    //     }
    //   ]
    // },
    {
      id: 'transactions',
      label: 'Transactions',
      icon: faArrowRightArrowLeft,
      roles: ['admin_solar', 'manager_solar'],
      groupId: 'sales',
      position: 12,
      submenus: [
        {
          id: 'addtransaction',
          label: 'Add Transaction',
          component: AddTransactionForm,
          icon: faPlus,
          roles: ['admin_solar', 'manager_solar']
        },
        {
          id: 'transactionsmanager',
          label: 'Transactions',
          component: CosmeticsTransactions,
          icon: faMoneyBillWave,
          roles: ['admin_solar', 'manager_solar']
        }
      ]
    },
    {
      id: 'barcode',
      label: 'Barcodes',
      icon: faQrcode,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      groupId: 'inventory',
      position: 13,
      submenus: [
        {
          id: 'barcodeprinting',
          label: 'Barcode Printing',
          component: MechanicsBarcode,
          icon: faPrint,
          roles: ['admin_solar', 'manager_solar', 'user_solar']
        }
      ]
    },
    {
      id: 'settings',
      label: 'Settings',
      icon: faGear,
      component: RootUsers,
      roles: ['admin_solar'],
      groupId: 'system',
      position: 14,
      submenus: []
    },
    {
      id: 'systemupdates',
      label: 'Notifications Center',
      icon: faBullhorn,
      component: MessageSystem,
      roles: ['admin_solar', 'manager_solar', 'user_solar'],
      groupId: 'system',
      position: 15,
      submenus: []
    }
  ],
  
  quickStats: [
    { id: 'todaySales', label: "Today's Sales", icon: 'faChartLine', value: '4,200' },
    { id: 'products', label: 'Products', icon: 'faBoxes', value: 78 },
    { id: 'customers', label: 'Customers', icon: 'faUsers', value: 45 },
    { id: 'pending', label: 'Pending Invoices', icon: 'faClock', value: 9 }
  ],
  
  shortcuts: [
    { key: 'Alt + D', description: 'Dashboard' },
    { key: 'Alt + C', description: 'Add Customer' },
    { key: 'Alt + L', description: 'Customer List' },
    { key: 'Alt + P', description: 'Stock List' },
    { key: 'Alt + S', description: 'New Sale' },
    { key: 'Alt + U', description: 'New Purchase' },
    { key: 'Alt + R', description: 'New Return' },
    { key: 'Alt + E', description: 'Add Employee' },
    { key: 'Alt + G', description: 'Employees List' },
    { key: 'Alt + V', description: 'Suppliers List' },
    { key: 'Alt + B', description: 'Barcode Printing' },
    { key: 'Ctrl + R / Cmd + R', description: 'Refresh Dashboard Data' },
    { key: 'Alt + H', description: 'Toggle Shortcuts Panel' }
  ]
};